// TSS vite/03 §"Query keys convention".

export const taskKeys = {
    all:    ['tasks'],
    list:   (params) => ['tasks', 'list', params],
    detail: (id)     => ['tasks', 'detail', id],
};

export const commitKeys = {
    all:   ['commits'],
    trace: (hash) => ['commits', 'trace', String(hash).toLowerCase()],
};
